export enum ContestStatusType {
    NULL = "NULL",
    EXPOSED = "EXPOSED",
    DELETE = "DELETE"
}
